import { MobileMetricCard } from '@/components/base/MobileUi';
import { useStore } from '@/hooks/useStore';
import { useAuth } from '@/hooks/useAuth';
import { getContractsByHtx } from '@/store';
import { formatCompactCurrency } from '@/utils/format';

export default function ContractStats() {
  useStore();
  const { user } = useAuth();
  const contracts = getContractsByHtx(user?.htxId).filter((contract) => !contract.isDeleted);
  const active = contracts.filter((contract) => contract.status === 'Đang hiệu lực').length;
  const allocated = contracts.reduce((sum, contract) => sum + (contract.hanMucDaCap || 0), 0);
  const totalValue = contracts.reduce((sum, contract) => sum + (contract.giaTri || 0), 0);

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      <MobileMetricCard label="Tổng hợp đồng" value={contracts.length} caption="Hồ sơ đang quản lý" icon="ri-file-list-3-line" tone="slate" />
      <MobileMetricCard label="Đang hiệu lực" value={active} caption="Có thể phát sinh nghiệp vụ" icon="ri-checkbox-circle-line" tone="emerald" />
      <MobileMetricCard label="Đã cấp hạn mức" value={formatCompactCurrency(allocated)} caption="Theo hợp đồng nông hộ" icon="ri-wallet-3-line" tone="amber" />
      <MobileMetricCard label="Tổng giá trị" value={formatCompactCurrency(totalValue)} caption="Giá trị toàn bộ hợp đồng" icon="ri-funds-line" tone="sky" />
    </div>
  );
}
